import { generateRecentIsoTimestamp } from "utils/timestamp";
const buses = {
  buses: [
    {
      busNo: "1",
      route: "Route#1",
      busIconType: "green",
      speed: "10 mph",
      fuelConsumed: "20 Gal",
      distanceCovered: "20 Miles",
      stops: "02/05",
      driver: "Ahmed Al Mansoori",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.5015,
          lng: 54.3850
        },
      },
      destination: {
        area: "Yas Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.4885,
          lng: 54.6050
        },
      },
      currentLocation: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.5015,
          lng: 54.3850
        },
      },
      nextStop: {
        area: "Al Reem Island",
        coOrdinates: {
          lat: 24.4833,
          lng: 54.3833
        },
      },
    },
    {
      busNo: "2",
      route: "Route#2",
      busIconType: "green",
      speed: "10 mph",
      fuelConsumed: "20 Gal",
      distanceCovered: "20 Miles",
      stops: "02/05",
      driver: "Mohammed Al Qubaisi",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Khalifa City",
        coOrdinates: {
          lat: 24.4205,
          lng: 54.5746
        },
      },
      destination: {
        area: "Al Raha Beach",
        coOrdinates: {
          lat: 24.4856,
          lng: 54.6080
        },
      },
      currentLocation: {
        area: "Khalifa City",
        coOrdinates: {
          lat: 24.4205,
          lng: 54.5746
        },
      },
      nextStop: {
        area: "Al Bahia",
        coOrdinates: {
          lat: 24.4167,
          lng: 54.4500
        },
      },
    },
    {
      busNo: "3",
      route: "Route#3",
      busIconType: "green",
      speed: "10 mph",
      fuelConsumed: "20 Gal",
      distanceCovered: "20 Miles",
      stops: "02/05",
      driver: "Omar Al Shamsi",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: {
          lat: 24.5401, // shifted within 10 miles
          lng: 54.4128
        },
      },
      destination: {
        area: "Sheikh Zayed Grand Mosque",
        coOrdinates: {
          lat: 24.4856,
          lng: 54.5529
        },
      },
      currentLocation: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: {
          lat: 24.5234,
          lng: 54.3789
        },
      },
      nextStop: {
        area: "Al Bateen",
        coOrdinates: {
          lat: 24.4687,
          lng: 54.4105
        },
      }
      ,
    },
    {
      busNo: "4",
      route: "Route#4",
      busIconType: "red",
      speed: "5 mph",
      fuelConsumed: "25 Gal",
      distanceCovered: "15 Miles",
      stops: "01/04",
      driver: "Khalid Al Ameri",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: {
          lat: 24.4667,
          lng: 54.3333
        },
      },
      destination: {
        area: "Sheikh Zayed Grand Mosque",
        coOrdinates: {
          lat: 24.4122,
          lng: 54.4747
        },
      },
      currentLocation: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: {
          lat: 24.4667,
          lng: 54.3333
        },
      },
      nextStop: {
        area: "Al Bateen",
        coOrdinates: {
          lat: 24.4500,
          lng: 54.3500
        },
      },
    },
    {
      busNo: "5",
      route: "Route#5",
      busIconType: "green",
      speed: "12 mph",
      fuelConsumed: "22 Gal",
      distanceCovered: "28 Miles",
      stops: "04/08",
      driver: "Fatima Al Dhaheri",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Musaffah Industrial Area",
        coOrdinates: {
          lat: 24.3500,
          lng: 54.4833
        },
      },
      destination: {
        area: "Abu Dhabi International Airport",
        coOrdinates: {
          lat: 24.4330,
          lng: 54.6511
        },
      },
      currentLocation: {
        area: "Musaffah Industrial Area",
        coOrdinates: {
          lat: 24.3500,
          lng: 54.4833
        },
      },
      nextStop: {
        area: "Shakhbout City",
        coOrdinates: {
          lat: 24.3833,
          lng: 54.5333
        },
      },
    },
    {
      busNo: "6",
      route: "Route#6",
      busIconType: "green",
      speed: "14 mph",
      fuelConsumed: "19 Gal",
      distanceCovered: "22 Miles",
      stops: "03/06",
      driver: "Mariam Al Zaabi",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Saadiyat Island",
        coOrdinates: {
          lat: 24.5333,
          lng: 54.4000
        },
      },
      destination: {
        area: "Al Mina",
        coOrdinates: {
          lat: 24.4833,
          lng: 54.3500
        },
      },
      currentLocation: {
        area: "Saadiyat Island",
        coOrdinates: {
          lat: 24.5333,
          lng: 54.4000
        },
      },
      nextStop: {
        area: "Al Zahiyah",
        coOrdinates: {
          lat: 24.4833,
          lng: 54.3500
        },
      },
    },
    {
      busNo: "7",
      route: "Route#7",
      busIconType: "green",
      speed: "13 mph",
      fuelConsumed: "21 Gal",
      distanceCovered: "26 Miles",
      stops: "03/05",
      driver: "Abdullah Al Nuaimi",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Al Shamkha",
        coOrdinates: {
          lat: 24.3000,
          lng: 54.5667
        },
      },
      destination: {
        area: "Bani Yas",
        coOrdinates: {
          lat: 24.2833,
          lng: 54.6167
        },
      },
      currentLocation: {
        area: "Al Shamkha",
        coOrdinates: {
          lat: 24.3000,
          lng: 54.5667
        },
      },
      nextStop: {
        area: "Al Wathba",
        coOrdinates: {
          lat: 24.2500,
          lng: 54.5833
        },
      },
    },
    {
      busNo: "8",
      route: "Route#8",
      busIconType: "red",
      speed: "7 mph",
      fuelConsumed: "17 Gal",
      distanceCovered: "14 Miles",
      stops: "02/04",
      driver: "Sultan Al Ketbi",
      timeStamp: generateRecentIsoTimestamp(),
      source: {
        area: "Al Karamah",
        coOrdinates: {
          lat: 24.4500,
          lng: 54.3667
        },
      },
      destination: {
        area: "Al Mushrif",
        coOrdinates: {
          lat: 24.4333,
          lng: 54.4000
        },
      },
      currentLocation: {
        area: "Al Karamah",
        coOrdinates: {
          lat: 24.4500,
          lng: 54.3667
        },
      },
      nextStop: {
        area: "Al Manhal",
        coOrdinates: {
          lat: 24.4333,
          lng: 54.3833
        },
      },
    },
  ],
};

export default buses;

// {
//   busNo: "4",
//   route: "Route#4",
//   busIconType: "yellow",
//   speed: "15 mph",
//   fuelConsumed: "18 Gal",
//   distanceCovered: "25 Miles",
//   stops: "03/07",
//   driver: "Maria Rodriguez",
//   timeStamp: generateRecentIsoTimestamp(),
//   source: {
//     area: "Liberia, Costa Rica",
//     coOrdinates: {
//       lat: 10.635707,
//       lng: -85.437866,
//     },
//   },
//   destination: {
//     area: "Playa del Coco",
//     coOrdinates: {
//       lat: 10.555556,
//       lng: -85.701111,
//     },
//   },
//   currentLocation: {
//     area: "Liberia, Costa Rica",
//     coOrdinates: {
//       lat: 10.635707,
//       lng: -85.437866,
//     },
//   },
//   nextStop: {
//     area: "El Sitio",
//     coOrdinates: {
//       lat: 10.621944,
//       lng: -85.520278,
//     },
//   },
// },

// {
//   busNo: "7",
//   route: "Route#7",
//   busIconType: "yellow",
//   speed: "18 mph",
//   fuelConsumed: "30 Gal",
//   distanceCovered: "35 Miles",
//   stops: "05/10",
//   driver: "Luis Fernandez",
//   timeStamp: generateRecentIsoTimestamp(),
//   source: {
//     area: "Cartago, Costa Rica",
//     coOrdinates: {
//       lat: 9.864497,
//       lng: -83.920685,
//     },
//   },
//   destination: {
//     area: "Turrialba",
//     coOrdinates: {
//       lat: 9.904445,
//       lng: -83.683334,
//     },
//   },
//   currentLocation: {
//     area: "Cartago, Costa Rica",
//     coOrdinates: {
//       lat: 9.864497,
//       lng: -83.920685,
//     },
//   },
//   nextStop: {
//     area: "Paraiso",
//     coOrdinates: {
//       lat: 9.838333,
//       lng: -83.865278,
//     },
//   },
// },

// {
//   busNo: "9",
//   route: "Route#9",
//   busIconType: "red",
//   speed: "8 mph",
//   fuelConsumed: "15 Gal",
//   distanceCovered: "12 Miles",
//   stops: "02/05",
//   driver: "Roberto Jimenez",
//   timeStamp: generateRecentIsoTimestamp(),
//   source: {
//     area: "Limón, Costa Rica",
//     coOrdinates: {
//       lat: 9.990371,
//       lng: -83.037498,
//     },
//   },
//   destination: {
//     area: "Cahuita",
//     coOrdinates: {
//       lat: 9.734722,
//       lng: -82.848611,
//     },
//   },
//   currentLocation: {
//     area: "Limón, Costa Rica",
//     coOrdinates: {
//       lat: 9.990371,
//       lng: -83.037498,
//     },
//   },
//   nextStop: {
//     area: "Pandora",
//     coOrdinates: {
//       lat: 9.916667,
//       lng: -82.983333,
//     },
//   },
// },
// {
//   busNo: "10",
//   route: "Route#10",
//   busIconType: "green",
//   speed: "20 mph",
//   fuelConsumed: "28 Gal",
//   distanceCovered: "40 Miles",
//   stops: "06/12",
//   driver: "Sofia Ramirez",
//   timeStamp: generateRecentIsoTimestamp(),
//   source: {
//     area: "Nicoya, Costa Rica",
//     coOrdinates: {
//       lat: 10.150000,
//       lng: -85.450000,
//     },
//   },
//   destination: {
//     area: "Samara",
//     coOrdinates: {
//       lat: 9.883333,
//       lng: -85.533333,
//     },
//   },
//   currentLocation: {
//     area: "Nicoya, Costa Rica",
//     coOrdinates: {
//       lat: 10.150000,
//       lng: -85.450000,
//     },
//   },
//   nextStop: {
//     area: "Garza",
//     coOrdinates: {
//       lat: 9.966667,
//       lng: -85.500000,
//     },
//   },
// },
// {
//   busNo: "11",
//   route: "Route#11",
//   busIconType: "yellow",
//   speed: "16 mph",
//   fuelConsumed: "24 Gal",
//   distanceCovered: "32 Miles",
//   stops: "04/07",
//   driver: "Javier Lopez",
//   timeStamp: generateRecentIsoTimestamp(),
//   source: {
//     area: "Quepos, Costa Rica",
//     coOrdinates: {
//       lat: 9.430556,
//       lng: -84.162500,
//     },
//   },
//   destination: {
//     area: "Manuel Antonio",
//     coOrdinates: {
//       lat: 9.392222,
//       lng: -84.141667,
//     },
//   },
//   currentLocation: {
//     area: "Quepos, Costa Rica",
//     coOrdinates: {
//       lat: 9.430556,
//       lng: -84.162500,
//     },
//   },
//   nextStop: {
//     area: "Villanueva",
//     coOrdinates: {
//       lat: 9.416667,
//       lng: -84.150000,
//     },
//   },
// },
